import globals from '../../utils/globals'

export default ({ user, extraClass }) => {
  const rankClasses = rank => rank
    ? `
  ${rank.isBold ? 'rank--bold' : ''}
  ${rank.isItalic ? 'rank--italic' : ''}
  ${rank.isUnderline ? 'rank--underlined' : ''}
  ` : ''

  return (
    user.id
      ? <a class={`link--user ${rankClasses(user.rank)} ${extraClass || ''}`}
        style={{ color: user.rank
          ? user.rank.color
          : ''
        }}
        href={globals('application') !== 'control' ? user.url : `/member/profile?userid=${user.id}`}>
        {user.name}
      </a>
      : <div class='link--user default-cursor'>{user.name}</div>
  )
}
